import { render, staticRenderFns } from "./schedule-table.vue?vue&type=template&id=3b2a47f8&scoped=true&"
import script from "./schedule-table.ts?vue&type=script&lang=ts&"
export * from "./schedule-table.ts?vue&type=script&lang=ts&"
import style0 from "./schedule-table.scss?vue&type=style&index=0&id=3b2a47f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a47f8",
  null
  
)

export default component.exports